import React from 'react';
import { Box } from '@mui/material';
import { HistoryOutlined } from '@mui/icons-material';
import { AlertBoxMsg } from '@qrios/frontend-library';
import locales from '../../locales';
import { DialogActionButtons, DialogDescription } from '../../../../../../../common/dialog';
import DetailsList from '../../../../../../../common/details-list';
import Divider from '../../../../../../../common/divider/divider';
import { InvitedUserItem } from '../../interfaces';
import { BusinessError } from '../../../../../../../common/business-error';
import { formatDateToClientFormat } from '../../../../../../../../constants/helpers/dates';

interface Props {
  item: InvitedUserItem;
  handleCloseDialog: () => void;
  handleSubmitAction: (invitationId: string) => void;
  loading: boolean;
  error?: BusinessError | null;
}

const ResendInvitation = ({ item, handleCloseDialog, handleSubmitAction, loading, error }: Props) => {
  const items = [
    { label: locales.resendModal.labels.email, value: item.emailAddress },
    { label: locales.resendModal.labels.invitationStatus, value: item.invitationStatus },
    { label: locales.resendModal.labels.role, value: item.role.name },
    { label: locales.resendModal.labels.roleDescription, value: item.role.description },
    {
      label: locales.resendModal.labels.expirationDate,
      value: formatDateToClientFormat({ date: item.expirationDate, type: 'exclusive' })
    }
  ];
  const actions = {
    primary: {
      type: 'button' as const,
      handler: () => handleSubmitAction(item.invitationId),
      text: locales.resendModal.button.title.resend
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseDialog,
      text: locales.resendModal.button.title.close
    }
  };

  return (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={HistoryOutlined}>
        <DetailsList items={items} />
        <Divider />
        You want to resend the invitation. The user will receive a new email with an invitation code. Click{' '}
        <b>Resend</b> to confirm.
      </DialogDescription>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} danger={false} />
    </Box>
  );
};

export default ResendInvitation;
